module.exports = __webpack_public_path__ + "img/system_1.143edb54.jpg";